import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";
import { UserService } from "../../../@core/services/user.service";

import QnA from "../../../models/qna.model";
import { QnAService } from "../../../services/qna.service";
import { DialogProfileComponent } from "../../dialog-profile/dialog-profile.component";
import { DialogQnAContentComponent } from "../../dialog-qna-content/dialog-qna-content.component";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { find, remove, clone } from "lodash";
import { Router } from "@angular/router";
import ReportSpam from "../../../models/report-spam.model";
import { filter, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "ngx-view-qna",
  styleUrls: ["./view-qna.component.scss"],
  templateUrl: "./view-qna.component.html",
})
export class ViewQnAComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() qna: QnA;
  @Input() mode?: string = "home"; //home / tutor / detail
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "question";
  uid = "";
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];
  isMobile = false;

  constructor(
    public userService: UserService,
    private qnaService: QnAService,
    private dialogService: NbDialogService,
    private router: Router,
    private nbMenuService: NbMenuService,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.qna.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$)
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  replyQnA() {
    this.view = "replies";
  }

  closeReplyQnA() {
    this.view = "main";
  }

  loadContent(value) {
    if (value && (this.isMobile || this.qna.sourceType == "document")) {
      this.router.navigateByUrl(`/qna/${this.qna.id}`);
    }
    this.isMore = value;
  }

  loadButtonAction(item) {
    if (item.createdBy === this.uid) {
      this.menuItems = [
        { title: "Sửa", icon: "edit-2-outline", data: item },
        { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/qna/${this.qna.id}`,
        },
      ];
    } else {
      this.menuItems = [
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/qna/${this.qna.id}`,
        },
      ];
    }
  }

  report(item: ReportSpam) {
    this.onDelete.emit(item.refId);
  }

  navigateRef(item: QnA) {
    if (item.courseId != "") {
      this.router.navigateByUrl(`/course/${item.courseId}`);
    } else if (item.quizId != "") {
      this.router.navigateByUrl(`/quiz/${item.quizId}`);
    }
  }

  tagSelected(tag) {
    console.log("tagSelected:", tag);
  }

  delete(id) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.qnaService
            .deleteQnA(id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.onDelete.emit(id);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  edit(item: QnA) {
    let qnaBk = new QnA();
    qnaBk = clone(item);
    this.dialogService
      .open(DialogQnAContentComponent, {
        context: {
          header: "Cập nhật câu hỏi",
          mode: "edit",
          qna: qnaBk,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.qna = value;
          this.onEdit.emit(value);
        }
      });
  }
}
